export default {
  "hero.h1": "Kakobuy Spreadsheet Polska – Znajdź najlepsze produkty szybciej",
  "hero.subtitle": "Kompletna baza Kakobuy Spreadsheet dla Polski. Odkrywaj popularne produkty, sprawdzaj kategorie, porównuj możliwości i korzystaj z praktycznych poradników zakupowych.",
  "hero.ctaPrimary": "Przejdź do Kakobuy Spreadsheet",
  "hero.ctaSecondary": "Zobacz poradnik dla początkujących",
  "hero.trustTitle": "Dlaczego użytkownicy wybierają Kakobuy Spreadsheet?",
  "hero.trust1.title": "Tysiące produktów",
  "hero.trust1.desc": "Poznaj popularne produkty znalezione przez społeczność.",
  "hero.trust2.title": "Kategorie produktów",
  "hero.trust2.desc": "Buty, ubrania, elektronika i wiele więcej.",
  "hero.trust3.title": "Praktyczne poradniki",
  "hero.trust3.desc": "Dowiedz się jak korzystać z Kakobuy bezpiecznie.",
  "hero.trust4.title": "Aktualne informacje",
  "hero.trust4.desc": "Regularnie aktualizowane treści i dane.",

  "categories.title": "Kategorie Produktów Kakobuy Spreadsheet",
  "categories.subtitle": "Przeglądaj wszystkie dostępne kategorie produktów w Kakobuy Spreadsheet. Wybierz interesującą Cię kategorię i odkryj najlepsze oferty.",
  "categories.dropdownLabel": "Wybierz kategorię",

  "stats.title": "Kakobuy Spreadsheet w liczbach",
  "stats.products": "Produktów",
  "stats.categories": "Kategorii",
  "stats.guides": "Poradników",
  "stats.access": "Dostęp",

  "content.title": "Kakobuy Spreadsheet – Kompletny przewodnik",
  "content.subtitle": "Wszystko co musisz wiedzieć o Kakobuy Spreadsheet",
  "content.readMore": "Czytaj więcej",
  "content.articleBtn": "Zobacz wszystkie artykuły",

  "safety.title": "Czy Kakobuy Spreadsheet jest bezpieczny?",
  "safety.subtitle": "Poznaj zasady bezpiecznego korzystania z platformy Kakobuy",
  "safety.tip1": "Zawsze sprawdzaj opinie innych użytkowników przed zakupem",
  "safety.tip2": "Korzystaj wyłącznie z oficjalnych linków i arkuszy",
  "safety.tip3": "Weryfikuj jakość produktów przez zdjęcia QC",
  "safety.tip4": "Używaj bezpiecznych metod płatności oferowanych przez platformę",
  "safety.tip5": "Sprawdzaj czas wysyłki i koszty przed złożeniem zamówienia",

  "faq.title": "Często zadawane pytania",
  "faq.subtitle": "Odpowiedzi na najczęściej zadawane pytania o Kakobuy Spreadsheet",
  "faq.q1": "Czym jest Kakobuy Spreadsheet?",
  "faq.a1": "Kakobuy Spreadsheet to kompleksowa baza danych produktów dostępnych na platformie Kakobuy. Zawiera szczegółowe informacje o produktach, kategoriach, cenach i linkach do zakupu. Dzięki arkuszowi możesz szybko znaleźć interesujące Cię produkty bez konieczności ręcznego przeszukiwania platformy.",
  "faq.q2": "Czy Kakobuy działa w Polsce?",
  "faq.a2": "Tak, Kakobuy w pełni obsługuje zamówienia do Polski. Platforma oferuje międzynarodową wysyłkę, a polscy użytkownicy mogą bez problemu zamawiać produkty i korzystać ze wszystkich funkcji platformy, w tym z arkusza Kakobuy Spreadsheet.",
  "faq.q3": "Czy Kakobuy Spreadsheet jest bezpieczny w użyciu?",
  "faq.a3": "Kakobuy Spreadsheet jest narzędziem informacyjnym tworzonym przez społeczność. Sam arkusz jest bezpieczny – zawiera wyłącznie dane o produktach. Zawsze jednak zalecamy weryfikację produktów przed zakupem i korzystanie z oficjalnych metod płatności platformy Kakobuy.",
  "faq.q4": "Jak znaleźć najlepsze produkty w Kakobuy Spreadsheet?",
  "faq.a4": "Najlepsze produkty znajdziesz przeglądając kategorie w arkuszu, sortując według popularności i ocen innych użytkowników. Warto również regularnie sprawdzać aktualizacje arkusza, ponieważ nowe produkty są dodawane na bieżąco.",
  "faq.q5": "Jak często aktualizowany jest Kakobuy Spreadsheet?",
  "faq.a5": "Kakobuy Spreadsheet jest regularnie aktualizowany przez społeczność użytkowników. Nowe produkty i kategorie są dodawane systematycznie, aby zapewnić dostęp do najświeższych informacji o ofercie platformy Kakobuy.",

  "comparison.title": "Kakobuy Spreadsheet vs Tradycyjne wyszukiwanie",
  "comparison.feature": "Funkcja",
  "comparison.spreadsheet": "Spreadsheet",
  "comparison.traditional": "Tradycyjne wyszukiwanie",
  "comparison.row1.feature": "Kategorie produktów",
  "comparison.row1.spreadsheet": "Tak, rozbudowane",
  "comparison.row1.traditional": "Ograniczone",
  "comparison.row2.feature": "Filtry zaawansowane",
  "comparison.row2.spreadsheet": "Tak, szczegółowe",
  "comparison.row2.traditional": "Podstawowe",
  "comparison.row3.feature": "Oszczędność czasu",
  "comparison.row3.spreadsheet": "Bardzo wysoka",
  "comparison.row3.traditional": "Niska",
  "comparison.row4.feature": "Organizacja danych",
  "comparison.row4.spreadsheet": "Profesjonalna",
  "comparison.row4.traditional": "Chaotyczna",
  "comparison.row5.feature": "Aktualizacje społeczności",
  "comparison.row5.spreadsheet": "Regularne",
  "comparison.row5.traditional": "Brak"
}